export default __webpack_public_path__ + "fonts/KD_logo.30311523de6147f46ef77ee2e975ced7.png";